
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, CircularProgress } from "@mui/material";

const SuccessPayment = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const redirectTimeout = setTimeout(() => {
            navigate('/souscriptions/consultation');
        }, 5000);

        return () => clearTimeout(redirectTimeout);
    }, [navigate]);

    return (
        <Container component="main" maxWidth="xs">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                <Typography component="h1" variant="h5">
                    Paiement réussi !
                </Typography>
                <Typography component="p" variant="body1" style={{ marginTop: '16px', marginBottom: '16px' }}>
                    Merci pour votre achat. Votre paiement a été effectué avec succès.
                </Typography>
                <CircularProgress style={{ marginTop: '16px' }} />
                <Typography component="p" variant="body2" style={{ marginTop: '16px' }}>
                    Redirection vers la page suivante...
                </Typography>
            </div>
        </Container>
    );
};

export default SuccessPayment;
